import Constants from 'expo-constants';
import { Platform } from 'react-native';

import { env } from 'utils/environment';

export const country = 'US';
export const sanityDataset = `${env()}_fhs_us`;
export const apiKey: string = Platform.select({
  web: Constants?.expoConfig?.extra?.eas?.US?.apiKeys?.launchDarkly,
  default: Constants?.expoConfig?.extra?.eas?.US?.apiKeys?.launchDarklyMobileKey,
});
